import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { NodeAction, selectedNodeSelector } from '@cbridge-packages/node';
import { queryParamSelector, RouterAction } from '@cbridge-packages/routing';
import { StreamParam } from '../_helpers/streamSearchParam';
import { NodeStreamsFilterAction } from '../streamsFilter.action';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>
  & IGetSelectorStateType<typeof selectedNodeSelector>;

export const toggleSelectNodeStreamEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(NodeStreamsFilterAction.toggleSelectStream),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { streamId } = payload;
    const currentId = queryParamSelector(state, StreamParam.name);
    const selectedNodeId = selectedNodeSelector(state);

    if (String(streamId) === currentId) {
      return [
        RouterAction.removeParam(StreamParam.name),
      ];
    }

    const actions = [];
    actions.push(RouterAction.addParam(StreamParam.nameAndValue(String(streamId))));

    if (selectedNodeId) {
      actions.push(NodeAction.clearSelect());
    }

    return actions;
  }),
);
